import type { PropsWithChildren } from 'react';
import type { ContainerProps, FlexProps } from '@chakra-ui/react';
import { Flex } from '@chakra-ui/react';

type Props = {
  containerProps?: ContainerProps;
  contentProps?: FlexProps;
  header?: React.ReactNode;
  footer?: React.ReactNode;
};

const COMMON_LAYOUT_PROPS: FlexProps = {
  maxW: '1560px',
  width: '100%',
  marginLeft: 'auto',
  marginRight: 'auto',
};

const BASE_CONTAINER_PADDING = { base: 0, md: 3.5 };

export const Layout = ({
  children,
  header,
  footer,
  ...props
}: PropsWithChildren<Props & FlexProps>) => (
  <Flex
    bg={{ base: 'white', md: 'neutral100' }}
    direction='column'
    height='100vh'
    paddingX={BASE_CONTAINER_PADDING}
    paddingTop={BASE_CONTAINER_PADDING}
    paddingBottom={footer ? 0 : BASE_CONTAINER_PADDING}
    overflow='hidden'>
    {header && (
      <Flex as='header' {...COMMON_LAYOUT_PROPS}>
        {header}
      </Flex>
    )}
    <Flex
      as='main'
      flex='1 1 auto'
      minH={0}
      flexDirection='column'
      height='100%'
      bg='white'
      borderRadius={{
        base: 0,
        md: '3xl',
      }}
      overflow='auto'
      {...COMMON_LAYOUT_PROPS}
      {...props}>
      {children}
    </Flex>
    {footer && (
      <Flex as='footer' {...COMMON_LAYOUT_PROPS}>
        {footer}
      </Flex>
    )}
  </Flex>
);
